@if (showDefaultGrey()) {
  <div class="listHints info">
    @for (validation of defaultValidation() ?? []; track $index) {
      <div class="greyListHint">
        <i nz-icon [nzType]="'icons:info'" class="svg-icon"></i>
        {{ i18n.parse(validation.message) }}
      </div>
    }
  </div>
}
@if (!!validations() && showValidation()) {
  <div class="listHints info">
    @for (validation of validations() ?? []; track $index) {
      @if (resolveIsValid()(item(), validation) && validation.validated) {
        <div class="greenListHint">
          <i nz-icon [nzType]="'icons:done-full-circle'" class="svg-icon"></i>
          {{ i18n.parse(validation.message) }}
        </div>
      }
      @if (!resolveIsValid()(item(), validation) && validation.validated) {
        <div class="redListHint">
          <i nz-icon [nzType]="'icons:cross-circle'" class="svg-icon"></i>
          {{ i18n.parse(validation.message) }}
        </div>
      }
      @if (!validation.validated) {
        <div class="greyListHint">
          <i nz-icon [nzType]="'icons:info'" class="svg-icon"></i>
          {{ i18n.parse(validation.message) }}
        </div>
      }
    }
  </div>
}
